import Cookies from 'js-cookie'
// cookie保存的天数
import config from '@/config'
const { cookieExpires } = config

export const TOKEN_KEY = 'token'

export const setToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) return token
  else return false
}

export const removeToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) Cookies.remove(TOKEN_KEY)
  
    const auth_token = Cookies.get('auth_token')
    if (auth_token) Cookies.remove('auth_token')
}

